if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.variantField = this.form?.querySelector('[name="id"]');
      if (this.variantField) this.variantField.disabled = false;
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = window.NihooyaCart?.getDrawer?.() || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (this.cartDrawer && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const cartDrawer = window.NihooyaCart?.getDrawer?.() || this.cartDrawer;
      const variantId = formData.get('id');

      if (!variantId) {
        this.handleErrorMessage('Please choose a product option.');
        return;
      }

      const sellingPlanId = typeof window.getCurrentSellingPlanId === 'function'
        ? window.getCurrentSellingPlanId()
        : '';
      if (sellingPlanId) {
        formData.append('selling_plan', sellingPlanId);
      }

      config.body = formData;

      const optimisticQty = parseInt(formData.get('quantity') || '1', 10) || 1;
      const currentCount = parseInt(
        document.querySelector('.nihooya-header__cart-badge')?.textContent || '0',
        10
      );

      if (cartDrawer) {
        window.NihooyaCart?.ensureDrawerReady?.();
        window.NihooyaCart?.optimisticAddFromForm(this.form, optimisticQty);
        window.NihooyaCart?.openDrawer(this.submitButton);
      }

      this.submitButton.classList.add('loading');

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (cartDrawer) {
              window.NihooyaCart?.fetchCart()
                .then((cart) => window.NihooyaCart?.patchDrawerFromCart(cart))
                .catch(() => window.NihooyaCart?.updateCount(currentCount));
            }

            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.description,
              message: response.message
            });

            const errorText = response.description || response.message || window.cartStrings?.error;
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            const isSoldOut = window.NihooyaCart?.isSoldOutError?.(errorText);

            if (isSoldOut && soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButton.disabled = true;
              this.submitButton.querySelectorAll('.nihooya-product-card__add-label, .nihooya-product-card__add-icon').forEach((element) => {
                element.classList.add('hidden');
              });
              const fallbackLabel = this.submitButton.querySelector('span:not(.sold-out-message):not(.loading-overlay__spinner)');
              if (fallbackLabel && !fallbackLabel.closest('.loading-overlay__spinner')) {
                fallbackLabel.classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.handleErrorMessage(errorText);
            this.error = true;
            return;
          }

          this.error = false;
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.disabled = false;

          if (!cartDrawer) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });

          const quickAddModal = this.closest('quick-add-modal');
          const syncCart = () => {
            window.NihooyaCart?.fetchCart()
              .then((cart) => window.NihooyaCart?.patchDrawerFromCart(cart))
              .catch((error) => console.error(error));
          };

          if (quickAddModal) {
            document.body.addEventListener('modalClosed', syncCart, { once: true });
            quickAddModal.hide(true);
            window.NihooyaCart?.openDrawer(this.submitButton);
          } else {
            syncCart();
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage(window.cartStrings?.error);
          if (cartDrawer) {
            window.NihooyaCart?.fetchCart()
              .then((cart) => window.NihooyaCart?.patchDrawerFromCart(cart))
              .catch(() => window.NihooyaCart?.updateCount(currentCount));
          }
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.disabled = false;
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}